import { t } from "i18next";
import ModificaPasswordPage from "../EditPassword/ModificaPasswordPage";

export const ResetPasswordModalContent = () => {
  return (
    <div>
      <p>{t("NewPasswordRequired")}</p>
      <ModificaPasswordPage />
    </div>
  );
};
